// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c59f1260","516":"aea920f1","566":"7a5809b3"}[chunkId] + ".chunk.js";
};